// removed by extract-text-webpack-plugin
module.exports = {"text800":"_3khbfczVaucXgCMDJuTOuk","text700":"_1IkAklp33ey-TI-FOtxVVp","text600":"ZAzKK4ZQy-1Vr06nn2JCr","text500":"_2UlTCENLP3sIT51LmxDde6","text400":"_2HcGjTG_PXI3gm2WgMCcm9","text300":"_30aRXpM7Rx1caoAy9jBDu-","text200":"_2H4kIvm93BnXzHWWHW8kDD","textParagraph":"_3ABTZWfBGgj3r5EtZ8p6Gk","crimp":"_2wWaOM0GR1fG4SmStJefR8","trim":"_1wbTO0UNn1yLfxU6GP4Kl9","flexCenter":"_34wdJSJaBIoRwortlyvfqx","hideTextOverflow":"_1X0M0s7Oa3y5iiT27eRqfB","marginPageMainContent":"_1sPJs8fOGk8G-bKiskQ5qy"};


//////////////////
// WEBPACK FOOTER
// ./src/imports/styles/styles.main.scss
// module id = 606
// module chunks = 0